import React from 'react';
import { Link } from 'react-router-dom';
import yccLogo from '../Assests/ycc logo.png';
import { FaFacebookF, FaYoutube, FaInstagram } from "react-icons/fa";


const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold mb-4">Yeole Classes</h3>
            <p className="text-gray-300 mb-4">
              Best Classes For Chemistry, Physics, Biology, Mathematics. Trusted by 10,000+ students.
              Preparing for NEET, JEE, and MHT-CET with expert faculty.
            </p>
            <div className="flex space-x-4 text-2xl">
              <a href="https://www.facebook.com/YeoleCareerInstitute/" className="p-2 bg-gray-800 rounded-full hover:bg-white hover:text-black transition">
                <FaFacebookF />
              </a>

              <a href="https://www.youtube.com/@YeoleClasses" className="p-2 bg-gray-800 rounded-full hover:bg-white hover:text-black transition">
                <FaYoutube />
              </a>

              <a href="https://www.instagram.com/yeole_classes_official?igsh=ZGFmcGxvemM2M3hs" className="p-2 bg-gray-800 rounded-full hover:bg-white hover:text-black transition">
                <FaInstagram />
              </a>
            </div>


          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/courses" className="text-gray-300 hover:text-white">Courses</Link></li>
              <li><Link to="/results" className="text-gray-300 hover:text-white">Results</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-white">About Us</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <ul className="space-y-2 text-gray-300">
              <li>📍 Majalgaon, Maharashtra 431131</li>
              <li>📞 +91-94047 95121</li>
              <li>📞 +91-88301 90142</li>
              <li>✉️ vijayeole8@gmail.com</li>
            </ul>
            {/* LOGO IMAGE ADDED HERE */}
            <div className="mt-4"> 
              <img
                src={yccLogo}
                alt="YCC Logo"
                className="w-40 rounded-md shadow-lg"
              />
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-300">
          <p>&copy; 2025 Yeole Classes. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;